var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg6602",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A171B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(4778.3553,368.93431)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6381",
    className: "st0",
    d: "M-4528.5,52.8c-93.9,0-171.8-77.9-171.8-171.8c0-4.9,0.2-9.7,0.6-14.5l143.7,9l-62.2,42.9 c-0.8,0.6-1.4,1.6-1.4,2.7c0,1.8,1.5,3.3,3.3,3.3h253.8C-4381.9-2.2-4449.5,52.8-4528.5,52.8 M-4528.5-290.7 c93.9,0,171.8,77.9,171.8,171.8c0,4.8-0.2,9.6-0.6,14.4l-143.6-9.1l62.3-42.7c0.8-0.6,1.4-1.6,1.4-2.7c0-1.8-1.5-3.3-3.2-3.3 h-254.1C-4675-235.6-4607.4-290.7-4528.5-290.7 M-4282.1-99.7l-47-3c0.4-5.3,0.7-10.7,0.7-16.2c0-110.5-89.5-200-200-200 c-95.6,0-175.5,67-195.3,156.7h-36.9c-2.4,0-4.6,1.1-5.9,2.9l-11,15.2c-0.5,0.6-0.8,1.4-0.8,2.3c0,2.1,1.7,3.8,3.8,3.8l46.8,2.9 c-0.4,5.4-0.7,10.8-0.7,16.3c0,110.5,89.5,200,200,200c95.6,0,175.5-67,195.3-156.7h37.1c2.4,0,4.6-1.1,5.9-2.9l11-15.2 c0.5-0.6,0.8-1.4,0.8-2.3C-4278.4-98.1-4280-99.7-4282.1-99.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpel);
export default __webpack_public_path__ + "static/media/opel.8b7f3651ddff4f382b1e596f08994540.svg";
export { ForwardRef as ReactComponent };